
export interface ProcessContainerInput {
    containerId: string;
    warehouseId: string;
    associate: string;
    locale?: string;
}

export interface ProcessContainerOutput {

}

export const buildProcessContainerInput = (containerId: string, warehouseId: string,
                                           associate: string, locale: string): ProcessContainerInput => {
    return {
        containerId,
        warehouseId,
        associate,
        locale
    }
}